import _ from 'lodash';
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import NotFoundPage from './NotFoundPage';
import "../styles/NewsDetailPage.css";
import { showFormatDate } from '../utils/Utils';
import { BASE_URL } from '../constants/Url';
import BackHome from '../components/BackHome';
import { Col, Skeleton } from 'antd';

export default function EventDetailPage() {
  const [data, setData] = useState({
    title: "",
    date: "",
    description: "",
    image: "",
    code: "",
  });
  const [notFound, setNotFound] = useState(false);
  const { code } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true); // 👈 loading true first

  useEffect(() => {
    const fetchData = () => {
      const param = { code: code }
      //fetch Data here

      if (!_.isEmpty(location) && !_.isEmpty(location.state) && !_.isEmpty(location.state.events)) {
        setData(location.state.events);
      } else {
        setNotFound(true);
      }
    }

    fetchData();
  }, [location, code])

  // ⏳ setTimeout 1 minute (1000ms) to switch loading -> data
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false); // 🔥 stop loading after 1min
    }, 2000);

    return () => clearTimeout(timer); // Cleanup if unmount
  }, []);

  return (
    <>
      {/* <BackHome title="Event" /> */}
      <div className='esi-std-container'>
        {
          notFound ?
            <NotFoundPage />
            :
            <div style={{ padding: "40px 0px" }}>
              {loading ? (
                <>
                  {Array(1).fill(0).map((_, index) => (
                    <Col key={index} xs={24} sm={24} md={24}>
                      <div key={index} className='cursor-pointer select-none esi-news-card' style={{ width: "100%" }}>
                        <div className='overflow-hidden max-sm:rounded-[1rem]'>
                          <Skeleton.Image rootClassName='esi-news-card-image' className='esi-news-card-image' active={true} />
                        </div>
                        <div className='text-start w-50 text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[50%] mt-3 line-clamp-2'>
                          <Skeleton.Input active block />
                        </div>
                        <div className='text-start w-full text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[100%] mt-3 line-clamp-2'>
                          <Skeleton.Input active block />
                          <Skeleton.Input active block />
                        </div>
                      </div>
                    </Col>
                  ))}
                </>
              ) : (

                <div className='esi-std-white-space flex flex-col gap-3'>
                  {data.image && <img className='news-image' src={BASE_URL + data.image} alt={data.title} />}
                  <h1 className='news-title'>{data && data.title}</h1>
                  <div className='news-published-date'>{!_.isEmpty(data?.date) && showFormatDate(data.date)}</div>
                  <div className='news-summary'>{data && data.description}</div>
                  <div className='flex items-center justify-between'>
                  </div>
                </div>
              )}
            </div>
        }
        <div className='esi-std-white-space'></div>
      </div>
    </>
  )
}
